import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'amendment-history',
  templateUrl: 'amendment-history.component.html',
  styleUrls: ['amendment-history.component.scss']
})

export class AmendmentHistoryComponent implements OnInit {
  @Input() amendmentHistory: any;

  constructor() {
  }

  ngOnInit() {
    this.amendmentHistory = this.amendmentHistory.filter(history => history.changes.length > 0);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/amendment-history/amendment-history.component.ts